/** Merchant settings (policy, refund modes, notifications, branding, go-live). */
import { endpoints } from '@/config/env';
import type { MerchantSettings, MerchantSettingsPatch } from '@/types';
import { request } from './client';

export function fetchSettings(signal?: AbortSignal): Promise<MerchantSettings | null> {
  return request<MerchantSettings | null>(endpoints.settings(), { signal });
}

export function updateSettings(patch: MerchantSettingsPatch): Promise<MerchantSettings | null> {
  return request<MerchantSettings | null>(endpoints.settings(), { method: 'PUT', body: patch });
}
